<div>
  <div [tabIndex]="0">
    <span class="list__item__date">{{ item.date | date: 'medium' }}</span>
    <p class="list__item__title" [routerLink]="['/info', slug]">{{ item.title }}</p>
    <p class="list__item__author" *ngIf="item.author">{{ item.author }}</p>
  </div>
  <app-rating class="interactions__rating" [rating]="item.rate"></app-rating>

  <app-remove-button [visualization]="item" (removed)="onRemoved($event)"></app-remove-button>
</div>
